import React, { Component } from "react"

import Fab from "@material-ui/core/Fab"
import ShoppingCart from "@material-ui/icons/ShoppingCart"
import Badge from "@material-ui/core/Badge"
import Tooltip from "@material-ui/core/Tooltip"

export default class CartButton extends Component {
  goToCheckout = () => {
    const { cart } = this.props

    const reservationUrl = `/Clinicians/Products/Checkout?CartId=${cart.id}`
    window.location = reservationUrl
  }

  render() {
    const { itemsInCart } = this.props

    return (
      <Tooltip
        title={
          <React.Fragment>
            Go to cart
            <span className="cart-tooltip-arrow" />
          </React.Fragment>
        }
        classes={{
          tooltip: "cart-tooltip",
        }}
      >
        <Fab color="primary" className="cart" onClick={this.goToCheckout}>
          <Badge badgeContent={itemsInCart}>
            <ShoppingCart />
          </Badge>
        </Fab>
      </Tooltip>
    )
  }
}
